import React from "react";
import { Alert, Typography } from "@mui/material";

/**
 * A reusable alert component with customizable properties
 * 
 * @param {Object} props - Component props
 * @param {string} props.severity - Alert severity (info, success, warning, error)
 * @param {React.ReactNode} props.icon - Icon to display
 * @param {string} props.message - Message to display
 * @param {Object} props.theme - Theme object
 * @param {Object} props.sx - Additional styles
 */
const CAlert = ({
  severity = "info",
  icon,
  message,
  theme,
  sx = {},
}) => {
  // Define styling based on severity
  const getAlertStyle = () => {
    switch (severity) {
      case "success":
        return {
          bgcolor: "rgba(122, 193, 66, 0.1)",
          color: theme.palette.text.primary,
          ".MuiAlert-icon": {
            color: theme.palette.secondary.main,
          },
        };
      case "info":
        return {
          bgcolor: "rgba(122, 193, 66, 0.1)",
          color: theme.palette.text.primary,
          ".MuiAlert-icon": {
            color: theme.palette.secondary.main,
          },
        };
      case "warning":
        return {
          bgcolor: "rgba(255, 152, 0, 0.1)",
          color: theme.palette.text.primary,
          ".MuiAlert-icon": {
            color: theme.palette.warning.main,
          },
        };
      case "error":
        return {
          bgcolor: "rgba(211, 47, 47, 0.1)",
          color: theme.palette.text.primary,
          ".MuiAlert-icon": {
            color: theme.palette.error.main,
          },
        };
      default:
        return {
          bgcolor: "rgba(122, 193, 66, 0.1)",
          color: theme.palette.text.primary,
          ".MuiAlert-icon": {
            color: theme.palette.secondary.main,
          },
        };
    }
  };

  return (
    <Alert
      severity={severity}
      icon={icon}
      sx={{
        ...getAlertStyle(),
        ...sx,
      }}
    >
      <Typography variant="body2">{message}</Typography>
    </Alert>
  );
};

export default CAlert;